module.exports = __webpack_public_path__ + "img/footer_04_brandk.2516a217.png";